<template>
  <header class="bg-blue-500 text-white p-4">
    <nav>
      <ul class="flex space-x-4">
        <li><router-link to="/" class="hover:text-blue-200">Accueil</router-link></li>
        <li><router-link to="/perso" class="hover:text-blue-200">Perso</router-link></li>
        <li><router-link to="/blog" class="hover:text-blue-200">Blog</router-link></li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
}
</script>

<style>
</style>

